import { Component } from '@angular/core';
import * as HighCharts from 'highcharts/highmaps';
import { IonicPage, MenuController, NavController, NavParams } from 'ionic-angular';
import { IMqttMessage, MqttService } from 'ngx-mqtt';

import { DashBangkaPage } from '../dash-bangka/dash-bangka';
import { DashBelitungPage } from '../dash-belitung/dash-belitung';
// import { DashMedanPage } from '../dash-medan/dash-medan';
import { DashDuriPage } from './../dash-duri/dash-duri';
import { DashLampungPage } from './../dash-lampung/dash-lampung';
import { DashLombokPage } from './../dash-lombok/dash-lombok';
import { DashNiasPage } from './../dash-nias/dash-nias';
import { DashPontianakPage } from './../dash-pontianak/dash-pontianak';

import { DashSuppaPage } from '../dash-suppa/dash-suppa';
import { DashTelloPage } from '../dash-tello/dash-tello';

declare var require: any;

const indonesiaMap = require("@highcharts/map-collection/countries/id/id-all.geo.json");

@IonicPage({
  name: "dashboard-page",
  segment: "dashboard",
})
@Component({
  selector: "page-dashboard",
  templateUrl: "dashboard.html",
})
export class DashboardPage {
  mppUnit: any = [
    {
      id: "NIA",
      name: "MPP Gunung Sitoli",
      lat: 1.2100701,
      lon: 97.6760703,
      value: 0,
      dataLabels: {
        x: 30,
        y: -40,
      },
    },
    {
      id: "DUR",
      name: "MPP Balai Pungut",
      lat: 1.0719337,
      lon: 101.2798429,
      value: 0,
      dataLabels: {
        x: 100,
        y: -50,
      },
    },
    {
      id: "BGK",
      name: "MPP Air Anyir",
      lat: -2.0770623,
      lon: 106.1468956,
      value: 0,
      dataLabels: {
        x: -5,
        y: -2,
      },
    },
    {
      id: "BLT",
      name: "MPP Suge",
      lat: -2.8915749,
      lon: 107.5638194,
      value: 0,
      dataLabels: {
        x: 70,
        y: -10,
      },
    },
    {
      id: "LMP",
      name: "MPP Tarahan",
      lat: -5.5184537,
      lon: 105.346001,
      value: 0,
      dataLabels: {
        x: 10,
        y: 50,
      },
    },
    {
      id: "PON",
      name: "MPP Parit Baru",
      lat: 0.0590372,
      lon: 109.2016659,
      value: 0,
      dataLabels: {
        x: 130,
        y: -70,
      },
    },
    {
      id: "LOM",
      name: "MPP Jeranjang",
      lat: -8.6598072,
      lon: 116.0720074,
      value: 0,
      dataLabels: {
        x: 20,
        y: 50,
      },
    },
    {
      id: "SUP",
      name: "MPP Suppa",
      lat: -3.9695245,
      lon: 119.6254039,
      value: 0,
      dataLabels: {
        x: 80,
        y: -30,
      },
    },
    {
      id: "TEL",
      name: "MPP Tello",
      lat: -5.147504,
      lon: 119.472032,
      value: 0,
      dataLabels: {
        x: 110,
        y: 50,
      },
    },
  ];

  //-5.1469105,119.4707865

  ENGINE: any = [
    "NIATM01",
    // "MDNTM02",
    // "MDNTM03",
    // "DURTM01",
    "DURTM02",
    "DURTM03",
    "BGKTM01",
    "BGKTM02",
    "BGKTM03",
    "BGKTM04",
    "LMPTM01",
    "LMPTM02",
    // "LMPTM03",
    // "LMPTM04",
    "BLTTM01",
    "PONTM01",
    "PONTM02",
    "PONTM03",
    "PONTM04",
    "LOMTM01",
    "LOMTM02",
    "SUPTM01",
    "SUPTM02"
  ];
  TAGS: any = ["U1_AQ7651"];

  TOPICS: any = [
    "mpp/nias01",
    // "mpp/medan02",
    // "mpp/medan03",
    // "mpp/duri01",
    "mpp/duri02",
    "mpp/duri03",
    "mpp/bangka01",
    "mpp/bangka02",
    "mpp/bangka03",
    "mpp/bangka04",
    "mpp/lampung01",
    "mpp/lampung02",
    // "mpp/lampung03",
    // "mpp/lampung04",
    "mpp/belitung01",
    "mpp/pontianak01",
    "mpp/pontianak02",
    "mpp/pontianak03",
    "mpp/pontianak04",
    "mpp/lombok01",
    "mpp/lombok02",
    "mpp/suppa01",
    "mpp/suppa02",
  ];
  MQTTSubscriber = {};
  data = {};

  mapChart: any;
  totalNIA: number;
  // totalMDN: number;
  totalDUR: number;
  totalBGK: number;
  totalLMP: number;
  totalBLT: number;
  totalPON: number;
  totalLOM: number;
  totalSUP: number;
  totalTEL: number;

  typed: any = ["TOTAL LOAD: 500 MW"];

  kondisinya: boolean = true;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private menuCtrl: MenuController,
    private mqttSvc: MqttService
  ) {
    this.structuringData();

    //Push view:
    // viewA push viewB
    //ionViewDidLoad() --> only if viewB is not already loaded
    //ionViewWillEnter()
    //ionViewDidEnter()
    // -- LEAVING:
    // ionViewWillLeave()
    // ionViewDidLeave()

    //Pop view:
    // viewA pop viewB
    // ionViewWillEnter()
    // ionViewDidEnter()
    // -- LEAVING
    // ionViewWillLeave()
    // ionVIewDidLeave()
    // ionViewWillUnload()
  }

  ionViewDidLoad() {
    this.menuCtrl.enable(true);
  }

  ionViewWillEnter() {
    this.subscribeMQTT();
  }

  ionViewDidEnter() {
    this.plotMapChart();
    this.setGrayMapNotConnected();
  }

  ionViewWillLeave() {
    Object.keys(this.MQTTSubscriber).forEach((key) => {
      this.MQTTSubscriber[key].unsubscribe();
    });
  }

  ionViewDidLeave() {}

  structuringData() {
    this.data["NIALAST"] = "...";
    // this.data["MDNLAST"] = "...";
    this.data["DURLAST"] = "...";
    this.data["BGKLAST"] = "...";
    this.data["LMPLAST"] = "...";
    this.data["BLTLAST"] = "...";
    this.data["PONLAST"] = "...";
    this.data["LOMLAST"] = "...";
    this.data["SUPLAST"] = "...";

    this.data["NIATM01"] = {};
    // this.data["MDNTM02"] = {};
    // this.data["MDNTM03"] = {};
    this.data["DURTM01"] = {};
    this.data["DURTM02"] = {};
    this.data["DURTM03"] = {};
    this.data["BGKTM01"] = {};
    this.data["BGKTM02"] = {};
    this.data["BGKTM03"] = {};
    this.data["BGKTM04"] = {};
    this.data["LMPTM01"] = {};
    this.data["LMPTM02"] = {};
    // this.data["LMPTM03"] = {};
    // this.data["LMPTM04"] = {};
    this.data["BLTTM01"] = {};
    this.data["PONTM01"] = {};
    this.data["PONTM02"] = {};
    this.data["PONTM03"] = {};
    this.data["PONTM04"] = {};
    this.data["LOMTM01"] = {};
    this.data["LOMTM02"] = {};

    this.data["SUPTM01"] = {};
    this.data["SUPTM02"] = {};

    this.TOPICS.forEach((topic) => {
      this.data[topic] = {};
      this.TAGS.forEach((tag) => {
        if (topic === "mpp/nias01") {
          this.data["NIATM01"][tag] = "...";
        // } else if (topic === "mpp/medan02") {
        //   this.data["MDNTM02"][tag] = "...";
        // } else if (topic === "mpp/medan03") {
        //   this.data["MDNTM03"][tag] = "...";
        // } else if (topic === "mpp/duri01") {
        //   this.data["DURTM01"][tag] = "...";
        } else if (topic === "mpp/duri02") {
          this.data["DURTM02"][tag] = "...";
        } else if (topic === "mpp/duri03") {
          this.data["DURTM03"][tag] = "...";
        } else if (topic === "mpp/bangka01") {
          this.data["BGKTM01"][tag] = "...";
        } else if (topic === "mpp/bangka02") {
          this.data["BGKTM02"][tag] = "...";
        } else if (topic === "mpp/bangka03") {
          this.data["BGKTM03"][tag] = "...";
        } else if (topic === "mpp/bangka04") {
          this.data["BGKTM04"][tag] = "...";
        } else if (topic === "mpp/lampung01") {
          this.data["LMPTM01"][tag] = "...";
        } else if (topic === "mpp/lampung02") {
          this.data["LMPTM02"][tag] = "...";
        // } else if (topic === "mpp/lampung03") {
        //   this.data["LMPTM03"][tag] = "...";
        // } else if (topic === "mpp/lampung04") {
        //   this.data["LMPTM04"][tag] = "...";
        } else if (topic === "mpp/belitung01") {
          this.data["BLTTM01"][tag] = "...";
        } else if (topic === "mpp/pontianak01") {
          this.data["PONTM01"][tag] = "...";
        } else if (topic === "mpp/pontianak02") {
          this.data["PONTM02"][tag] = "...";
        } else if (topic === "mpp/pontianak03") {
          this.data["PONTM03"][tag] = "...";
        } else if (topic === "mpp/pontianak04") {
          this.data["PONTM04"][tag] = "...";
        } else if (topic === "mpp/lombok01") {
          this.data["LOMTM01"][tag] = "...";
        } else if (topic === "mpp/lombok02") {
          this.data["LOMTM02"][tag] = "...";
        } else if (topic === "mpp/suppa01") {
          this.data["SUPTM01"][tag] = "...";
        } else if (topic === "mpp/suppa02") {
          this.data["SUPTM02"][tag] = "...";
        }
      });
    });
  }

  plotMapChart() {
    this.mapChart = HighCharts.mapChart("mapChart", {
      chart: {
        map: indonesiaMap as any,
      },
      title: {
        text: null,
      },
      exporting: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      mapNavigation: {
        enabled: true,
        buttonOptions: {
          alignTo: "spacingBox",
        },
      },
      tooltip: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        mappoint: {
          dataLabels: {
            allowOverlap: true,
            backgroundColor: "rgba(252,145,6,0.5)",
            borderColor: "rgba(252,145,6,0.8)",
            borderWidth: 1,
            crop: false,
            color: "#52505d",
            formatter: function () {
              var z = "";
              if (this.point.name === "MPP Gunung Sitoli") {
                z = "NIAS - 1 x 25 MW";
              // } else if (this.point.name === "MPP Paya Pasir") {
              //   z = "MEDAN - 2 x 25 MW";
              } else if (this.point.name === "MPP Balai Pungut") {
                z = "DURI - 2 x 25 MW";
              } else if (this.point.name === "MPP Air Anyir") {
                z = "BANGKA - 4 x 25 MW";
              } else if (this.point.name === "MPP Suge") {
                z = "BELITUNG - 1 x 25 MW";
              } else if (this.point.name === "MPP Tarahan") {
                z = "LAMPUNG - 2 x 25 MW";
              } else if (this.point.name === "MPP Parit Baru") {
                z = "PONTIANAK - 4 x 25 MW";
              } else if (this.point.name === "MPP Jeranjang") {
                z = "LOMBOK - 2 x 25 MW";
              } else if (this.point.name === "MPP Suppa") {
                z = "SUPPA - 2 x 25 MW";
              } else if (this.point.name === "MPP Tello") {
                z = "TELLO - 2 x 25 MW";
              }

              var t =
                '<span style="display:block;font-weight:bold">' +
                this.point.name.toUpperCase() +
                '</span><span style="display:block;font-size:9px;">' +
                z +
                '</span><span style="display:block;">LOAD: <b>' +
                this.point.value +
                " MW </b></span>";
              return t;
            },
            shape: "callout",
            style: {
              fontFamily: "PT Sans Narrow",
              fontSize: "10px",
              fontWeight: "normal",
              textShadow: "none",
            },
            useHTML: true,
          },
        },
        series: {
          point: {
            events: {
              click: function (e) {
                const p = e.point;
                // console.log('clicked : ' + p.name);
                if (p.name === "MPP Gunung Sitoli") {
                  this.openMPP("NIA");
                // } else if (p.name === "MPP Paya Pasir") {
                //   this.openMPP("MDN");
                } else if (p.name === "MPP Balai Pungut") {
                  this.openMPP("DUR");
                } else if (p.name === "MPP Air Anyir") {
                  this.openMPP("BGK");
                } else if (p.name === "MPP Tarahan") {
                  this.openMPP("LMP");
                } else if (p.name === "MPP Suge") {
                  this.openMPP("BLT");
                } else if (p.name === "MPP Parit Baru") {
                  this.openMPP("PON");
                } else if (p.name === "MPP Jeranjang") {
                  this.openMPP("LOM");
                } else if (p.name === "MPP Suppa") {
                  this.openMPP("SUP");
                } else if (p.name === "MPP Tello") {
                  // this.openMPP("LOM");
                }
              }.bind(this),
            },
          },
          marker: { symbol: "circle" },
        },
      },
      series: [
        {
          type: "map",
          name: "Basemap",
          borderColor: "#52505d",
          nullColor: "#63696D",
          showInLegend: false,
          enableMouseTracking: false,
          dataLabels: { enabled: false },
          joinBy: ["hc-key", "code"],
        },
        {
          type: "mapline",
          name: "Separators",
          nullColor: "#DEDEDE",
          showInLegend: false,
          enableMouseTracking: false,
        },
        {
          type: "mappoint",
          name: "PLN Batam Mobile Power Plant",
          enableMouseTracking: true,
          color: "#f9963b",
          data: this.mppUnit,
        },
      ],
    });
  }

  updateLabelMaps(mpp) {
    if (mpp === "NIA") {
      var unit1_nia;

      if (this.data["NIATM01"]["U1_AQ7651"] !== undefined) {
        unit1_nia = this.data["NIATM01"]["U1_AQ7651"];
      } else {
        unit1_nia = 0;
      }

      this.totalNIA = parseFloat(unit1_nia);

      if (this.totalNIA > 0) {
        this.mapChart.series[2].points[0].update({
          value: this.totalNIA.toFixed(2),
          color: "#75c363",
          dataLabels: {
            backgroundColor: "rgba(117,195,99,0.5)",
            borderColor: "rgba(117,195,99,0.8)",
            x: 30,
            y: -40,
          },
        });
      } else if (this.totalNIA <= 0) {
        this.mapChart.series[2].points[0].update({
          value: this.totalNIA.toFixed(2),
          color: "#f9963b",
          dataLabels: {
            backgroundColor: "rgba(252,145,6,0.5)",
            borderColor: "rgba(252,145,6,0.8)",
            x: 30,
            y: -40,
          },
        });
      }
    // } else if (mpp === "MDN") {
    //   // var unit1_mdn;
    //   var unit2_mdn;
    //   var unit3_mdn;

    //   // if (this.data["MDNTM01"]["U1_AQ7651"] !== undefined) {
    //   //   unit1_mdn = this.data["MDNTM01"]["U1_AQ7651"];
    //   // } else {
    //   //   unit1_mdn = 0;
    //   // }
    //   if (this.data["MDNTM02"]["U1_AQ7651"] !== undefined) {
    //     unit2_mdn = this.data["MDNTM02"]["U1_AQ7651"];
    //   } else {
    //     unit2_mdn = 0;
    //   }
    //   if (this.data["MDNTM03"]["U1_AQ7651"] !== undefined) {
    //     unit3_mdn = this.data["MDNTM03"]["U1_AQ7651"];
    //   } else {
    //     unit3_mdn = 0;
    //   }

    //   this.totalMDN = parseFloat(unit2_mdn) + parseFloat(unit3_mdn);

    //   if (this.totalMDN > 0) {
    //     this.mapChart.series[2].points[1].update({
    //       value: this.totalMDN.toFixed(2),
    //       color: "#75c363",
    //       dataLabels: {
    //         backgroundColor: "rgba(117,195,99,0.5)",
    //         borderColor: "rgba(117,195,99,0.8)",
    //         x: 45,
    //         y: -30,
    //       },
    //     });
    //   } else if (this.totalMDN <= 0) {
    //     this.mapChart.series[2].points[1].update({
    //       value: this.totalMDN.toFixed(2),
    //       color: "#f9963b",
    //       dataLabels: {
    //         backgroundColor: "rgba(252,145,6,0.5)",
    //         borderColor: "rgba(252,145,6,0.8)",
    //         x: 45,
    //         y: -30,
    //       },
    //     });
    //   }
    } else if (mpp === "DUR") {
      var unit2_dur;
      var unit3_dur;

      if (this.data["DURTM02"]["U1_AQ7651"] !== undefined) {
        unit2_dur = this.data["DURTM02"]["U1_AQ7651"];
      } else {
        unit2_dur = 0;
      }
      if (this.data["DURTM03"]["U1_AQ7651"] !== undefined) {
        unit3_dur = this.data["DURTM03"]["U1_AQ7651"];
      } else {
        unit3_dur = 0;
      }

      this.totalDUR = parseFloat(unit2_dur) + parseFloat(unit3_dur);

      if (this.totalDUR > 0) {
        this.mapChart.series[2].points[1].update({
          value: this.totalDUR.toFixed(2),
          color: "#75c363",
          dataLabels: {
            backgroundColor: "rgba(117,195,99,0.5)",
            borderColor: "rgba(117,195,99,0.8)",
            x: 100,
            y: -50,
          },
        });
      } else if (this.totalDUR <= 0) {
        this.mapChart.series[2].points[1].update({
          value: this.totalDUR.toFixed(2),
          color: "#f9963b",
          dataLabels: {
            backgroundColor: "rgba(252,145,6,0.5)",
            borderColor: "rgba(252,145,6,0.8)",
            x: 100,
            y: -50,
          },
        });
      }
    } else if (mpp === "BGK") {
      var unit1_bgk;
      var unit2_bgk;
      var unit3_bgk;
      var unit4_bgk;

      if (this.data["BGKTM01"]["U1_AQ7651"] !== undefined) {
        unit1_bgk = this.data["BGKTM01"]["U1_AQ7651"];
      } else {
        unit1_bgk = 0;
      }
      if (this.data["BGKTM02"]["U1_AQ7651"] !== undefined) {
        unit2_bgk = this.data["BGKTM02"]["U1_AQ7651"];
      } else {
        unit2_bgk = 0;
      }
      if (this.data["BGKTM03"]["U1_AQ7651"] !== undefined) {
        unit3_bgk = this.data["BGKTM03"]["U1_AQ7651"];
      } else {
        unit3_bgk = 0;
      }
      if (this.data["BGKTM04"]["U1_AQ7651"] !== undefined) {
        unit4_bgk = this.data["BGKTM04"]["U1_AQ7651"];
      } else {
        unit4_bgk = 0;
      }

      this.totalBGK = parseFloat(unit1_bgk) + parseFloat(unit2_bgk) + parseFloat(unit3_bgk) + parseFloat(unit4_bgk);

      if (this.totalBGK > 0) {
        this.mapChart.series[2].points[2].update({
          value: this.totalBGK.toFixed(2),
          color: "#75c363",
          dataLabels: {
            backgroundColor: "rgba(117,195,99,0.5)",
            borderColor: "rgba(117,195,99,0.8)",
            x: -5,
            y: -2,
          },
        });
      } else if (this.totalBGK <= 0) {
        this.mapChart.series[2].points[2].update({
          value: this.totalBGK.toFixed(2),
          color: "#f9963b",
          dataLabels: {
            backgroundColor: "rgba(252,145,6,0.5)",
            borderColor: "rgba(252,145,6,0.8)",
            x: -5,
            y: -2,
          },
        });
      }
    } else if (mpp === "LMP") {
      var unit1_lmp;
      var unit2_lmp;
      // var unit3_lmp;
      // var unit4_lmp;

      if (this.data["LMPTM01"]["U1_AQ7651"] !== undefined) {
        unit1_lmp = this.data["LMPTM01"]["U1_AQ7651"];
      } else {
        unit1_lmp = 0;
      }
      if (this.data["LMPTM02"]["U1_AQ7651"] !== undefined) {
        unit2_lmp = this.data["LMPTM02"]["U1_AQ7651"];
      } else {
        unit2_lmp = 0;
      }
      // if (this.data["LMPTM03"]["U1_AQ7651"] !== undefined) {
      //   unit3_lmp = this.data["LMPTM03"]["U1_AQ7651"];
      // } else {
      //   unit3_lmp = 0;
      // }
      // if (this.data["LMPTM04"]["U1_AQ7651"] !== undefined) {
      //   unit4_lmp = this.data["LMPTM04"]["U1_AQ7651"];
      // } else {
      //   unit4_lmp = 0;
      // }

      this.totalLMP =
        parseFloat(unit1_lmp) +
        parseFloat(unit2_lmp);

        // parseFloat(unit3_lmp) +
        // parseFloat(unit4_lmp);

      if (this.totalLMP > 0) {
        this.mapChart.series[2].points[4].update({
          value: this.totalLMP.toFixed(2),
          color: "#75c363",
          dataLabels: {
            backgroundColor: "rgba(117,195,99,0.5)",
            borderColor: "rgba(117,195,99,0.8)",
            x: 10,
            y: 50,
          },
        });
      } else if (this.totalLMP <= 0) {
        this.mapChart.series[2].points[4].update({
          value: this.totalLMP.toFixed(2),
          color: "#f9963b",
          dataLabels: {
            backgroundColor: "rgba(252,145,6,0.5)",
            borderColor: "rgba(252,145,6,0.8)",
            x: 10,
            y: 50,
          },
        });
      }
    } else if (mpp === "BLT") {
      var unit1_blt;

      if (this.data["BLTTM01"]["U1_AQ7651"] !== undefined) {
        unit1_blt = this.data["BLTTM01"]["U1_AQ7651"];
      } else {
        unit1_blt = 0;
      }

      this.totalBLT = parseFloat(unit1_blt);

      if (this.totalBLT > 0) {
        this.mapChart.series[2].points[3].update({
          value: this.totalBLT.toFixed(2),
          color: "#75c363",
          dataLabels: {
            backgroundColor: "rgba(117,195,99,0.5)",
            borderColor: "rgba(117,195,99,0.8)",
            x: 70,
            y: -10,
          },
        });
      } else if (this.totalBLT <= 0) {
        this.mapChart.series[2].points[3].update({
          value: this.totalBLT.toFixed(2),
          color: "#f9963b",
          dataLabels: {
            backgroundColor: "rgba(252,145,6,0.5)",
            borderColor: "rgba(252,145,6,0.8)",
            x: 70,
            y: -10,
          },
        });
      }
    } else if (mpp === "PON") {
      var unit1_PON;
      var unit2_PON;
      var unit3_PON;
      var unit4_PON;

      if (this.data["PONTM01"]["U1_AQ7651"] !== undefined) {
        unit1_PON = this.data["PONTM01"]["U1_AQ7651"];
      } else {
        unit1_PON = 0;
      }
      if (this.data["PONTM02"]["U1_AQ7651"] !== undefined) {
        unit2_PON = this.data["PONTM02"]["U1_AQ7651"];
      } else {
        unit2_PON = 0;
      }
      if (this.data["PONTM03"]["U1_AQ7651"] !== undefined) {
        unit3_PON = this.data["PONTM03"]["U1_AQ7651"];
      } else {
        unit3_PON = 0;
      }
      if (this.data["PONTM04"]["U1_AQ7651"] !== undefined) {
        unit4_PON = this.data["PONTM04"]["U1_AQ7651"];
      } else {
        unit4_PON = 0;
      }

      this.totalPON =
        parseFloat(unit1_PON) +
        parseFloat(unit2_PON) +
        parseFloat(unit3_PON) +
        parseFloat(unit4_PON);

      if (this.totalPON > 0) {
        this.mapChart.series[2].points[5].update({
          value: this.totalPON.toFixed(2),
          color: "#75c363",
          dataLabels: {
            backgroundColor: "rgba(117,195,99,0.5)",
            borderColor: "rgba(117,195,99,0.8)",
            x: 130,
            y: -70,
          },
        });
      } else if (this.totalPON <= 0) {
        this.mapChart.series[2].points[5].update({
          value: this.totalPON.toFixed(2),
          color: "#f9963b",
          dataLabels: {
            backgroundColor: "rgba(252,145,6,0.5)",
            borderColor: "rgba(252,145,6,0.8)",
            x: 130,
            y: -70,
          },
        });
      }
    } else if (mpp === "LOM") {
      var unit1_lom;
      var unit2_lom;

      if (this.data["LOMTM01"]["U1_AQ7651"] !== undefined) {
        unit1_lom = this.data["LOMTM01"]["U1_AQ7651"];
      } else {
        unit1_lom = 0;
      }
      if (this.data["LOMTM02"]["U1_AQ7651"] !== undefined) {
        unit2_lom = this.data["LOMTM02"]["U1_AQ7651"];
      } else {
        unit2_lom = 0;
      }

      this.totalLOM = parseFloat(unit1_lom) + parseFloat(unit2_lom);

      if (this.totalLOM > 0) {
        this.mapChart.series[2].points[6].update({
          value: this.totalLOM.toFixed(2),
          color: "#75c363",
          dataLabels: {
            backgroundColor: "rgba(117,195,99,0.5)",
            borderColor: "rgba(117,195,99,0.8)",
            x: 20,
            y: 50,
          },
        });
      } else if (this.totalLOM <= 0) {
        this.mapChart.series[2].points[6].update({
          value: this.totalLOM.toFixed(2),
          color: "#f9963b",
          dataLabels: {
            backgroundColor: "rgba(252,145,6,0.5)",
            borderColor: "rgba(252,145,6,0.8)",
            x: 20,
            y: 50,
          },
        });
      }
    } else if (mpp === "SUP") {
      var unit1_sup;
      var unit2_sup;

      if (this.data["SUPTM01"]["U1_AQ7651"] !== undefined) {
        unit1_sup = this.data["SUPTM01"]["U1_AQ7651"];
      } else {
        unit1_sup = 0;
      }
      if (this.data["SUPTM02"]["U1_AQ7651"] !== undefined) {
        unit2_sup = this.data["SUPTM02"]["U1_AQ7651"];
      } else {
        unit2_sup = 0;
      }

      this.totalSUP = parseFloat(unit1_sup) + parseFloat(unit2_sup);

      if (this.totalSUP > 0) {
        this.mapChart.series[2].points[7].update({
          value: this.totalSUP.toFixed(2),
          color: "#75c363",
          dataLabels: {
            backgroundColor: "rgba(117,195,99,0.5)",
            borderColor: "rgba(117,195,99,0.8)",
            x: 80,
            y: -30,
          },
        });
      } else if (this.totalSUP <= 0) {
        this.mapChart.series[2].points[7].update({
          value: this.totalSUP.toFixed(2),
          color: "#f9963b",
          dataLabels: {
            backgroundColor: "rgba(252,145,6,0.5)",
            borderColor: "rgba(252,145,6,0.8)",
            x: 80,
            y: -30,
          },
        });
      }
    }
  }

  setGrayMapNotConnected() {
    // MPP NIAS
    // this.mapChart.series[2].points[0].update({
    //   color: "#a7a5a3",
    //   dataLabels: {
    //     backgroundColor: "rgba(148, 145, 141, 0.5)",
    //     borderColor: "rgba(112, 110, 107, 0.8)",
    //     x: 70,
    //     y: -10,
    //   },
    // });
    // // MPP PONTIANAK
    // this.mapChart.series[2].points[6].update({
    //   color: "#a7a5a3",
    //   dataLabels: {
    //     backgroundColor: "rgba(148, 145, 141, 0.5)",
    //     borderColor: "rgba(112, 110, 107, 0.8)",
    //     x: 170,
    //     y: -40,
    //   },
    // });
    // // MPP LOMBOK
    // this.mapChart.series[2].points[7].update({
    //   color: "#a7a5a3",
    //   dataLabels: {
    //     backgroundColor: "rgba(148, 145, 141, 0.5)",
    //     borderColor: "rgba(112, 110, 107, 0.8)",
    //     x: 140,
    //     y: 50,
    //   },
    // });
  }

  subscribeMQTT() {
    this.TOPICS.forEach((topic) => {
      this.MQTTSubscriber[topic] = this.mqttSvc
        .observe(topic)
        .subscribe((message: IMqttMessage) => {
          var payload: any = this.binArrayToJson(message.payload);

          payload.forEach((data) => {
            var x_tag = data.id.split(".")[2];
            if (x_tag === "U1_AQ7651") {
              // DIV 1000
              if (data.v === 0) {
                if (topic === "mpp/nias01") {
                  this.data["NIATM01"][x_tag] = data.v.toFixed(2);
                // } else if (topic === "mpp/medan02") {
                //   this.data["MDNTM02"][x_tag] = data.v.toFixed(2);
                // } else if (topic === "mpp/medan03") {
                //   this.data["MDNTM03"][x_tag] = data.v.toFixed(2);
                // } else if (topic === "mpp/duri01") {
                //   this.data["DURTM01"][x_tag] = data.v.toFixed(2);
                } else if (topic === "mpp/duri02") {
                  this.data["DURTM02"][x_tag] = data.v.toFixed(2);
                } else if (topic === "mpp/duri03") {
                  this.data["DURTM03"][x_tag] = data.v.toFixed(2);
                } else if (topic === "mpp/bangka01") {
                  this.data["BGKTM01"][x_tag] = data.v.toFixed(2);
                } else if (topic === "mpp/bangka02") {
                  this.data["BGKTM02"][x_tag] = data.v.toFixed(2);
                } else if (topic === "mpp/bangka03") {
                  this.data["BGKTM03"][x_tag] = data.v.toFixed(2);
                } else if (topic === "mpp/bangka04") {
                  this.data["BGKTM04"][x_tag] = data.v.toFixed(2);
                }  else if (topic === "mpp/lampung01") {
                  this.data["LMPTM01"][x_tag] = data.v.toFixed(2);
                } else if (topic === "mpp/lampung02") {
                  this.data["LMPTM02"][x_tag] = data.v.toFixed(2);
                // } else if (topic === "mpp/lampung03") {
                //   this.data["LMPTM03"][x_tag] = data.v.toFixed(2);
                // } else if (topic === "mpp/lampung04") {
                //   this.data["LMPTM04"][x_tag] = data.v.toFixed(2);
                } else if (topic === "mpp/belitung01") {
                  this.data["BLTTM01"][x_tag] = data.v.toFixed(2);
                } else if (topic === "mpp/pontianak01") {
                  this.data["PONTM01"][x_tag] = data.v.toFixed(2);
                } else if (topic === "mpp/pontianak02") {
                  this.data["PONTM02"][x_tag] = data.v.toFixed(2);
                } else if (topic === "mpp/pontianak03") {
                  this.data["PONTM03"][x_tag] = data.v.toFixed(2);
                } else if (topic === "mpp/pontianak04") {
                  this.data["PONTM04"][x_tag] = data.v.toFixed(2);
                } else if (topic === "mpp/lombok01") {
                  this.data["LOMTM01"][x_tag] = data.v.toFixed(2);
                } else if (topic === "mpp/lombok02") {
                  this.data["LOMTM02"][x_tag] = data.v.toFixed(2);
                } else if (topic === "mpp/suppa01") {
                  this.data["SUPTM01"][x_tag] = data.v.toFixed(2);
                } else if (topic === "mpp/suppa02") {
                  this.data["SUPTM02"][x_tag] = data.v.toFixed(2);
                }
              } else {
                if (topic === "mpp/nias01") {
                  this.data["NIATM01"][x_tag] = (data.v / 1000).toFixed(2);
                // } else if (topic === "mpp/medan02") {
                //   this.data["MDNTM02"][x_tag] = (data.v / 1000).toFixed(2);
                // } else if (topic === "mpp/medan03") {
                //   this.data["MDNTM03"][x_tag] = (data.v / 1000).toFixed(2);
                // } else if (topic === "mpp/duri01") {
                //   this.data["DURTM01"][x_tag] = (data.v / 1000).toFixed(2);
                } else if (topic === "mpp/duri02") {
                  this.data["DURTM02"][x_tag] = (data.v / 1000).toFixed(2);
                } else if (topic === "mpp/duri03") {
                  this.data["DURTM03"][x_tag] = (data.v / 1000).toFixed(2);
                } else if (topic === "mpp/bangka01") {
                  this.data["BGKTM01"][x_tag] = (data.v / 1000).toFixed(2);
                } else if (topic === "mpp/bangka02") {
                  this.data["BGKTM02"][x_tag] = (data.v / 1000).toFixed(2);
                } else if (topic === "mpp/bangka03") {
                  this.data["BGKTM03"][x_tag] = (data.v / 1000).toFixed(2);
                } else if (topic === "mpp/bangka04") {
                  this.data["BGKTM04"][x_tag] = (data.v / 1000).toFixed(2);
                } else if (topic === "mpp/lampung01") {
                  this.data["LMPTM01"][x_tag] = (data.v / 1000).toFixed(2);
                } else if (topic === "mpp/lampung02") {
                  this.data["LMPTM02"][x_tag] = (data.v / 1000).toFixed(2);
                // } else if (topic === "mpp/lampung03") {
                //   this.data["LMPTM03"][x_tag] = (data.v / 1000).toFixed(2);
                // } else if (topic === "mpp/lampung04") {
                //   this.data["LMPTM04"][x_tag] = (data.v / 1000).toFixed(2);
                } else if (topic === "mpp/belitung01") {
                  this.data["BLTTM01"][x_tag] = (data.v / 1000).toFixed(2);
                } else if (topic === "mpp/pontianak01") {
                  this.data["PONTM01"][x_tag] = (data.v / 1000).toFixed(2);
                } else if (topic === "mpp/pontianak02") {
                  this.data["PONTM02"][x_tag] = (data.v / 1000).toFixed(2);
                } else if (topic === "mpp/pontianak03") {
                  this.data["PONTM03"][x_tag] = (data.v / 1000).toFixed(2);
                } else if (topic === "mpp/pontianak04") {
                  this.data["PONTM04"][x_tag] = (data.v / 1000).toFixed(2);
                } else if (topic === "mpp/lombok01") {
                  this.data["LOMTM01"][x_tag] = (data.v / 1000).toFixed(2);
                } else if (topic === "mpp/lombok02") {
                  this.data["LOMTM02"][x_tag] = (data.v / 1000).toFixed(2);
                } else if (topic === "mpp/suppa01") {
                  this.data["SUPTM01"][x_tag] = (data.v / 1000).toFixed(2);
                } else if (topic === "mpp/suppa02") {
                  this.data["SUPTM02"][x_tag] = (data.v / 1000).toFixed(2);
                }
              }

              this.updateLabelMaps("NIA");
              // this.updateLabelMaps("MDN");
              this.updateLabelMaps("DUR");
              this.updateLabelMaps("BGK");
              this.updateLabelMaps("LMP");
              this.updateLabelMaps("BLT");
              this.updateLabelMaps("PON");
              this.updateLabelMaps("LOM");
              this.updateLabelMaps("SUP");
            }

            if (topic === "mpp/nias01") {
              if (
                this.data["NIALAST"] === "..." ||
                this.data["NIALAST"] < data.t
              )
                this.data["NIALAST"] = data.t;
            // } else if (
            //   topic === "mpp/medan02" ||
            //   topic === "mpp/medan03"
            // ) {
            //   if (
            //     this.data["MDNLAST"] === "..." ||
            //     this.data["MDNLAST"] < data.t
            //   )
            //     this.data["MDNLAST"] = data.t;
            } else if (
              topic === "mpp/duri02" ||
              topic === "mpp/duri03"
            ) {
              if (
                this.data["DURLAST"] === "..." ||
                this.data["DURLAST"] < data.t
              )
                this.data["DURLAST"] = data.t;
            } else if (topic === "mpp/bangka01" || topic === "mpp/bangka02" || topic === "mpp/bangka03" || topic === "mpp/bangka04") {
              if (
                this.data["BGKLAST"] === "..." ||
                this.data["BGKLAST"] < data.t
              )
                this.data["BGKLAST"] = data.t;
            } else if (
              topic === "mpp/lampung01" ||
              topic === "mpp/lampung02"
              // ||
              // topic === "mpp/lampung03" ||
              // topic === "mpp/lampung04"
            ) {
              if (
                this.data["LMPLAST"] === "..." ||
                this.data["LMPLAST"] < data.t
              )
                this.data["LMPLAST"] = data.t;
            } else if (topic === "mpp/belitung01") {
              if (
                this.data["BLTLAST"] === "..." ||
                this.data["BLTLAST"] < data.t
              )
                this.data["BLTLAST"] = data.t;
            } else if (
              topic === "mpp/pontianak01" ||
              topic === "mpp/pontianak02" ||
              topic === "mpp/pontianak03" ||
              topic === "mpp/pontianak04"
            ) {
              if (
                this.data["PONLAST"] === "..." ||
                this.data["PONLAST"] < data.t
              )
                this.data["PONLAST"] = data.t;
            } else if (topic === "mpp/lombok01" || topic === "mpp/lombok02") {
              if (
                this.data["LOMLAST"] === "..." ||
                this.data["LOMLAST"] < data.t
              )
                this.data["LOMLAST"] = data.t;
            } else if (topic === "mpp/suppa01" || topic === "mpp/suppa02") {
              if (
                this.data["SUPLAST"] === "..." ||
                this.data["SUPLAST"] < data.t
              )
                this.data["SUPLAST"] = data.t;
            }
          });
        });
    });
  }

  openMPP(mpp) {
    if (mpp === "NIA") {
      this.navCtrl.push(DashNiasPage);
    } else if (mpp === "DUR") {
      this.navCtrl.push(DashDuriPage);
    } else if (mpp === "BGK") {
      this.navCtrl.push(DashBangkaPage);
    } else if (mpp === "LMP") {
      this.navCtrl.push(DashLampungPage);
    } else if (mpp === "BLT") {
      this.navCtrl.push(DashBelitungPage);
    } else if (mpp === "PON") {
      this.navCtrl.push(DashPontianakPage);
    } else if (mpp === "LOM") {
      this.navCtrl.push(DashLombokPage);
    } else if (mpp === "SUP") {
      this.navCtrl.push(DashSuppaPage);
    } else if (mpp === "TEL") {
      this.navCtrl.push(DashTelloPage);
    }
  }

  JsonToArray(json) {
    var str = JSON.stringify(json, null, 0);
    var ret = new Uint8Array(str.length);
    for (var i = 0; i < str.length; i++) {
      ret[i] = str.charCodeAt(i);
    }
    return ret;
  }

  binArrayToJson(binArray) {
    var str = "";
    for (var i = 0; i < binArray.length; i++) {
      str += String.fromCharCode(parseInt(binArray[i]));
    }
    return JSON.parse(str);
  }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/dashboard.ts